import React, { useState, useEffect } from "react";
import {
  // Link as Goto,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../../features/auth/authSlice";

//import viewIcon from "../../../assets/images/icons/view.png";
import editIcon from "../../../assets/images/icons/edit.svg";
//import editIconPNG from "../../../assets/images/icons/edit.png";
import addIcon from "../../../assets/images/icons/addIcon.png";
import closeIcon from "../../../assets/images/icons/close.svg";
import deleteIcon from "../../../assets/images/icons/Delete.svg";
import downloadIcon from "../../../assets/images/icons/download.svg";
import linkIcon from "../../../assets/images/icons/gotoLink.svg";
import DataTable from "../../common/DataTable/DataTable";
import { nanoid } from "@reduxjs/toolkit";
import "./ViewTask.css";
import {
  useGetTaskDetailsQuery,
  useCompleteTaskMutation,
  useLinkDocumentMutation,
  useCloseTaskMutation,
  useUpdateTaskAssigneeMutation,
  // useUpdateTaskProgressMutation,
  useUpdateTaskMutation,
} from "../../../features/MyTasks/taskSlice";
import { format } from "date-fns";
import { Loader } from "../../common/Loader/Loader";

import toast, { Toaster } from "react-hot-toast";

import ConfirmationModal from "../../common/ConfirmationModal/ConfirmationModal";
import { DatePickerComponent } from "@syncfusion/ej2-react-calendars";
import { taskStatus } from "../../../enums/statuses";
import { userRoles } from "../../../enums/userRoles";
import AttachmentModal from "../../common/AttachmentModal/AttachmentModal";
import {
  useDeleteAttachedDocumentMutation,
  useDownloadAttachFileMutation,
} from "../../../features/Incidents/IncidentSlice";
import { goToFile, sanitizeInputValue } from "../../../utils/commonMethods";
import UserMultiSelect from "../../common/UserMultiSelect/UserMultiSelect";

const ViewTask = () => {
  const user = useSelector(selectCurrentUser);
  const { taskId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const {
    data: taskDetails,
    isLoading: taskDetailsIsLoading,
    error: taskDetailsError,
  } = useGetTaskDetailsQuery(taskId);

  const [completeTask] = useCompleteTaskMutation();
  const [linkDocument] = useLinkDocumentMutation();
  const [closeTask, { isLoading: closeTaskIsLoading }] = useCloseTaskMutation();
  const [addTaskAssignee, { isLoading: addTaskAssigneeIsLoading }] =
    useUpdateTaskAssigneeMutation();
  const [updateTask, { isLoading: updateTaskIsLoading }] =
    useUpdateTaskMutation();
  const [deleteAttachedDocument] = useDeleteAttachedDocumentMutation();
  const [triggerDownload] = useDownloadAttachFileMutation();

  const isNotStandardUser =
    user &&
    [userRoles.ADMIN, userRoles.ENHANCED_MANAGER, userRoles.MANAGER].some(
      (role) => user.roles.includes(role)
    );

  const [taskDetailsData, setTaskDetailsData] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [editDescription, setEditDescription] = useState(false);
  const [editAssignee, setEditAssignee] = useState(false);
  const [editNote, setEditNote] = useState(false);
  const [editDueDate, setEditDueDate] = useState(false);

  const [notes, setNotes] = useState("");
  const [description, setDescription] = useState("");
  const [dueDate, setDueDate] = useState(null);
  const [actionType, setActionType] = useState("");
  const [addAttachmentModalIsOpen, setAddAttachmentModalIsOpen] =
    useState(false);

  const attachmentColoumns = [
    {
      key: nanoid(),
      field: "id",
      headerText: "ID",
      alignment: "left",
      template: null,
      width: "100px",
    },
    {
      key: nanoid(),
      field: "name",
      headerText: "File Name",
      alignment: "left",
      template: null,
      width: "250px",
    },
    {
      key: nanoid(),
      field: "description",
      headerText: "File Description",
      alignment: "left",
      template: null,
      width: "250px",
    },
    {
      key: nanoid(),
      field: "createdOn",
      headerText: "Created On",
      alignment: "left",
      template: (props) => (
        <span>
          {props?.createdOn ? format(props?.createdOn, "dd/mm/yyyy") : "-"}
        </span>
      ),
      width: "150px",
    },
    {
      key: nanoid(),
      field: "createdBy",
      headerText: "Created By",
      alignment: "left",
      template: (props) => <span>{props.createdBy?.name}</span>,
      width: "200px",
    },
    {
      key: nanoid(),
      field: "options",
      headerText: "Options",
      template: (props) => (
        <div>
          {props.blobUrl && (
            <button
              className="e-btn e-flat option-btn me-1"
              title="Go to File"
              onClick={() => {
                handleAttachmentDownload(props?.id, props?.name);
              }}
            >
              <img alt="download" src={downloadIcon} width={25} />
            </button>
          )}
          {props.link && (
            <button
              className="e-btn e-flat option-btn me-1"
              title="Go to File"
              onClick={() => goToFile(props?.link)}
            >
              <img alt="link" src={linkIcon} width={25} />
            </button>
          )}

          <button
            className="e-btn e-flat option-btn"
            title="Delete File"
            onClick={() => handleDeleteAttachedDocument(props?.id)}
          >
            <img alt="delete" src={deleteIcon} width={25} />
          </button>
        </div>
      ),
      width: "200px",
    },
  ];

  const toggleAddAttachmentModal = () => {
    setAddAttachmentModalIsOpen((prev) => !prev);
  };

  useEffect(() => {
    if (taskDetails) {
      const data = taskDetails.ids.map((id) => {
        return taskDetails.entities[id];
      });
      setTaskDetailsData({
        ...data[0],
        assignedTo: data[0]?.assignedTo?.map((assignee) => ({
          value: assignee?.id,
          label: `${assignee?.name} (${assignee?.email ?? ""})`,
        })),
      });

      setDescription(data[0]?.description);
      setNotes(data[0]?.notes);
      setDocuments(
        data[0].linkDocuments?.map((docs) => ({
          ...docs?.attachment,
          documentId: docs?.id,
        }))
      );
    }
    if (taskDetailsError) {
      const { status, data } = taskDetailsError;

      if (status === 403) {
        toast.error("You don't have permission to access this task details.");
        navigate(
          `/incidents/view/${location.state?.from || ""}/${
            location.state?.tab || ""
          }`
        );
        return;
      }

      toast.error(
        `Failed to fetch task details: ${
          data?.Message || data?.title || "Something unexpected happened!"
        }`
      );
    }
  }, [taskDetails, taskDetailsError, navigate, taskId]);

  let rteObj;

  const statusId = taskDetailsData?.status?.id;
  const statusClassName =
    statusId === taskStatus.COMPLETED
      ? "complete"
      : statusId === taskStatus.INPROGRESS
      ? "ongoing"
      : "";

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const toggleModal = () => {
    setModalIsOpen(!modalIsOpen);
  };

  const handleComplete = async () => {
    try {
      toggleModal();

      const incidentId = location.state?.from;
      await toast.promise(
        completeTask(taskId)
          .unwrap()
          .then(() => {
            if (incidentId) {
              navigate(`/incidents/view/${incidentId}/true`);
            } else {
              navigate(-1);
            }
          }),
        {
          loading: "Completing...",
          success: "Task completed successfully!",
          error: (err) =>
            `Completing task failed: ${
              err?.data?.Message ||
              err?.data?.title ||
              "Something unexpected happened!"
            }`,
        }
      );
    } catch (error) {
      toast.error(
        error?.data?.Message ||
          "An unexpected error occurred while completing the task."
      );
    }
  };

  const linkDocumentToTask = async (id) => {
    try {
      if (id) {
        await linkDocument({
          attachmentDocumentId: id,
          id: taskId,
        }).unwrap();
      }

      toast.success("Attachment added Successfully...!");
    } catch (error) {
      toast.error(error?.data?.Message || error?.data?.title);
    }
  };

  const handleDeleteAttachedDocument = async (id) => {
    try {
      const requestPromise = deleteAttachedDocument(id).unwrap();
      toast.promise(requestPromise, {
        success: "Attachment Deleted Successfully...!",
        loading: "Deleting...",
        error: "Something Went Wrong...!",
      });
      await requestPromise;
    } catch (error) {
      toast.error(error?.data?.Message);
    }
  };

  const handleNoteSubmit = async (e, isDescription) => {
    e.preventDefault();
    try {
      await updateTask({
        id: taskId,
        notes,
        description,
        name: taskDetailsData?.name,
      }).unwrap();
      if (isDescription) {
        setEditDescription(false);
      } else {
        setEditNote(false);
      }
      toast.success(
        `${isDescription ? "Description" : "Note"}  Updated successfully`
      );
    } catch (error) {
      toast.error(error?.data?.Message);
    }
  };

  const handleDueDateSubmit = async () => {
    if (!dueDate) {
      return;
    }
    try {
      await updateTask({
        id: taskId,
        notes: taskDetailsData?.notes ?? "",
        description: taskDetailsData?.description,
        name: taskDetailsData?.name,
        dueDate,
      }).unwrap();
      setEditDueDate(false);
      toast.success("Due Date Updated successfully");
      setDueDate(null);
    } catch (error) {
      toast.error(error?.data?.Message);
    }
  };

  const handleAddAssignee = async (users) => {
    if (!users?.length > 0) {
      return;
    }

    const formattedData = users?.map((user) => ({ userId: user?.value }));
    try {
      await addTaskAssignee({
        id: taskId,
        assignedTo: formattedData,
      }).unwrap();
      toast.success("Assignee Updated successfully");
      setEditAssignee(false);
    } catch (error) {
      toast.error(error?.data?.Message);
    }
  };
  const handleCloseTask = async () => {
    try {
      await closeTask(taskId).unwrap();
      toast.success("Task Closed successfully");
      navigate(-1);
    } catch (error) {
      toast.error(error?.data?.Message);
    }
  };

  const handleClick = (type) => {
    setActionType(type);
    toggleModal();
  };

  const handleAttachmentDownload = async (attachmentId, attachmentName) => {
    try {
      const responsePromise = triggerDownload({
        id: attachmentId,
        filename: attachmentName,
      }).unwrap();

      toast.promise(responsePromise, {
        loading: "Downloading...",
        success: "Downloaded Successfully...!",
        error: (err) =>
          `${
            err?.data?.Message ||
            err?.data?.title ||
            "Something went wrong while downloading attachment...!"
          }`,
      });
      await responsePromise;
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="view-task">
      {(taskDetailsIsLoading ||
        updateTaskIsLoading ||
        addTaskAssigneeIsLoading ||
        closeTaskIsLoading) && (
        <div className="loader-container">
          <Loader />
        </div>
      )}
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#0b463d",
            color: "#ffffff",
          },
          success: {
            iconTheme: {
              secondary: "#ffffff",
            },
          },
        }}
      />
      <div className="card custom-card view-task-card">
        <div className="card-body blue" style={{ position: "relative" }}>
          <div className="row mb-3">
            <div className="col">
              <div className="card custom-card img-card banner">
                <div className="">
                  <div className="card-body custom-card-body">
                    <span
                      className={`status-pill custom-pill mb-3 ${statusClassName}  `}
                    >
                      {taskDetailsData?.status?.description}
                    </span>
                    <p className="fs-4 mb-3">
                      <strong>Task: </strong> {taskDetailsData?.name}
                    </p>
                    {/* <p>
                      Due on: &nbsp;
                      {taskDetailsData &&
                        format(taskDetailsData?.dueOn, "dd/MM/yyyy")}
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="button-panel">
            <div className="row justify-content-end">
              <div className="col-auto">
                {taskDetailsData?.incident?.guid && (
                  <button
                    className="btn btn-green-outline m-1"
                    style={{ minWidth: "180px" }}
                    onClick={() => {
                      navigate(
                        `/incidents/view/${taskDetailsData?.incident?.guid}/${
                          location.state?.tab || 97
                        }`
                      );
                    }}
                  >
                    {location.state?.from === taskDetailsData?.incident?.guid
                      ? "Back to Incident"
                      : "Go to Incident"}
                  </button>
                )}
                {taskDetailsData?.canEdit && (
                  <>
                    {taskDetailsData?.status?.id === 2 && (
                      <button
                        className="btn btn-green m-1"
                        style={{ minWidth: "180px" }}
                        onClick={() => handleClick("complete")}
                      >
                        Complete
                      </button>
                    )}
                    {/* {taskDetailsData?.status?.id !== 3 && (
                      <button
                        className="btn btn-grey m-1"
                        style={{ minWidth: "180px" }}
                        onClick={() => handleClick("close")}
                      >
                        Close
                      </button>
                    )} */}
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col">
              <h6>
                Description
                {isNotStandardUser && (
                  <button
                    className="e-btn e-flat option-btn ms-2"
                    onClick={() => {
                      setDescription(taskDetailsData?.description);
                      setEditDescription((prev) => !prev);
                    }}
                  >
                    {editDescription ? (
                      <img
                        alt="close"
                        src={closeIcon}
                        width={26}
                        className="p-1"
                      />
                    ) : (
                      <img
                        alt="edit"
                        src={editIcon}
                        width={26}
                        className="p-1"
                      />
                    )}
                  </button>
                )}
              </h6>

              <div className="task-description">
                {editDescription ? (
                  <form onSubmit={(e) => handleNoteSubmit(e, true)}>
                    <div className="mb-3">
                      <textarea
                        className="form-control"
                        rows="5"
                        value={description}
                        onChange={(e) => {
                          const cleanInput = sanitizeInputValue(e.target.value);
                          setDescription(cleanInput);
                        }}
                      ></textarea>
                    </div>
                    <div className="mb-1">
                      <button
                        className="btn btn-green me-3"
                        style={{ minWidth: "180px" }}
                        type="submit"
                      >
                        Save
                      </button>
                      <button
                        className="btn btn-grey"
                        style={{ minWidth: "180px" }}
                        type="button"
                        onClick={() => setDescription("")}
                      >
                        Clear
                      </button>
                    </div>
                  </form>
                ) : taskDetailsData?.description ? (
                  taskDetailsData?.description
                ) : (
                  "Enter text here ..."
                )}
              </div>
            </div>
          </div>
          <div className="row mb-3 justify-content-even align-items-center">
            <div className="col-12 col-md-4">
              <h6 className="d-flex align-items-center">
                Assign To
                {taskDetailsData?.canEdit && (
                  <button
                    className="e-btn e-flat option-btn ms-2"
                    onClick={() => setEditAssignee((prev) => !prev)}
                  >
                    {editAssignee ? (
                      <img
                        alt="close"
                        src={closeIcon}
                        width={26}
                        className="p-1"
                      />
                    ) : (
                      <img
                        alt="edit"
                        src={editIcon}
                        width={26}
                        className="p-1"
                      />
                    )}
                  </button>
                )}
              </h6>
              <div className="task-description ">
                {editAssignee ? (
                  <UserMultiSelect
                    placeholder="Select Assignee"
                    values={taskDetailsData?.assignedTo || []}
                    onChange={handleAddAssignee}
                  />
                ) : (
                  <div className="d-flex gap-2 flex-wrap">
                    {taskDetailsData?.assignedTo &&
                    taskDetailsData?.assignedTo?.length > 0
                      ? taskDetailsData?.assignedTo?.map((assignee) => (
                          <span
                            key={`assignee${assignee?.value}`}
                            className="bg-dark-subtle p-1 rounded"
                          >
                            {assignee.label}{" "}
                          </span>
                        ))
                      : "Unassigned"}
                  </div>
                )}
              </div>
            </div>
            {/* <div className="col-12 col-md-4">
              <h6 className="d-flex align-items-center">
                Progress
                {taskDetailsData?.canEdit && (
                  <button
                    className="e-btn e-flat option-btn ms-2"
                    onClick={() => setEditProgress((prev) => !prev)}
                  >
                    {editProgress ? (
                      <img src={closeIcon} width={26} className="p-1" />
                    ) : (
                      <img src={editIcon} width={26} className="p-1" />
                    )}
                  </button>
                )}
              </h6>
              <div
                className="task-description d-flex align-items-center"
                style={{ padding: "0.3em 1em" }}
              >
                <SliderComponent
                  id={taskDetailsData?.id}
                  min={0}
                  max={100}
                  value={taskProgress}
                  change={(args) => setTaskProgress(args.value)}
                  enabled={editProgress}
                />
                <span className="ms-3">{taskProgress}%</span>
                {editProgress && (
                  <div>
                    <button
                      className="btn btn-green  ms-3"
                      style={{ minWidth: "100px" }}
                      onClick={handleUpdateProgress}
                    >
                      Save
                    </button>
                  </div>
                )}
              </div>
            </div> */}
            <div className="col-12 col-md-4">
              <h6 className="d-flex align-items-center">
                Due Date
                {taskDetailsData?.canEdit && (
                  <button
                    className="e-btn e-flat option-btn ms-2"
                    onClick={() => setEditDueDate((prev) => !prev)}
                  >
                    {editDueDate ? (
                      <img
                        alt="close"
                        src={closeIcon}
                        width={26}
                        className="p-1"
                      />
                    ) : (
                      <img
                        alt="edit"
                        src={editIcon}
                        width={26}
                        className="p-1"
                      />
                    )}
                  </button>
                )}
              </h6>
              <div className="task-description">
                {editDueDate ? (
                  <div className="d-flex justify-content-between align-items-center">
                    <DatePickerComponent
                      id="datepicker"
                      value={format(taskDetailsData?.dueOn, "dd/MM/yyyy")}
                      change={(args) =>
                        args.value &&
                        setDueDate(format(args.value, "yyyy-MM-dd"))
                      }
                      min={new Date()}
                      // max={maxDate}
                    />

                    <button
                      className="btn btn-green  ms-3"
                      style={{ minWidth: "100px" }}
                      onClick={handleDueDateSubmit}
                    >
                      Save
                    </button>
                  </div>
                ) : taskDetailsData?.dueOn ? (
                  format(taskDetailsData?.dueOn, "dd/MM/yyyy")
                ) : (
                  "N/A"
                )}
              </div>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col">
              <h6 className="d-flex align-items-center">
                Notes
                {taskDetailsData?.canEdit && (
                  <button
                    className="e-btn e-flat option-btn ms-2"
                    onClick={() => {
                      setNotes(taskDetailsData?.notes);
                      setEditNote((prev) => !prev);
                    }}
                  >
                    {editNote ? (
                      <img
                        alt="close"
                        src={closeIcon}
                        width={26}
                        className="p-1"
                      />
                    ) : (
                      <img
                        alt="edit"
                        src={editIcon}
                        width={26}
                        className="p-1"
                      />
                    )}
                  </button>
                )}
              </h6>

              <div className="task-description">
                {editNote ? (
                  <form onSubmit={(e) => handleNoteSubmit(e, false)}>
                    <div className="mb-3">
                      <textarea
                        className="form-control"
                        rows="5"
                        value={notes}
                        onChange={(e) => {
                          const cleanInput = sanitizeInputValue(e.target.value);
                          setNotes(cleanInput);
                        }}
                      ></textarea>
                    </div>
                    <div className="mb-1">
                      <button
                        className="btn btn-green me-3"
                        style={{ minWidth: "180px" }}
                        type="submit"
                      >
                        Save
                      </button>
                      <button
                        className="btn btn-grey"
                        style={{ minWidth: "180px" }}
                        type="button"
                        onClick={() => setNotes("")}
                      >
                        Clear
                      </button>
                    </div>
                  </form>
                ) : taskDetailsData?.notes ? (
                  taskDetailsData?.notes
                ) : (
                  "Enter text here ..."
                )}
              </div>
            </div>
          </div>
          {taskDetailsData?.canLinkDocuments && (
            <div className="card custom-card ">
              <div className="card-body">
                <div className="row justify-content-between align-items-center mb-3">
                  <div className="col-auto">
                    <h6>Linked Documents</h6>
                  </div>
                  {/* <div className="col-auto">
                    <div className="d-flex align-items-center">
                      <div className="input-group">
                        <label
                          htmlFor="searchDocuments"
                          className="input-group-text search-icon-container"
                        >
                          <img
                            src={searchIcon}
                            alt="Search Icon"
                            className="icon-image"
                            width={12}
                          />
                        </label>
                        <input
                          id="searchDocuments"
                          type="text"
                          className="form-control search"
                          placeholder="Search Documents"
                        />
                      </div>
                      <button className="btn btn-filter" onClick={() => {}}>
                        <img src={filterIcon} width={34} alt="" />
                      </button>
                    </div>
                  </div> */}
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="row mb-4 justify-content-start align-items-center">
                      <div className="col-auto">
                        {taskDetailsData?.canEdit && (
                          <button
                            className="btn btn-green btn-icon px-5"
                            onClick={toggleAddAttachmentModal}
                          >
                            <span className="me-2">Add Document</span>
                            <img src={addIcon} width={22} alt="add" />
                          </button>
                        )}
                      </div>
                    </div>

                    {documents.length > 0 ? (
                      <DataTable
                        grid={rteObj}
                        data={documents}
                        columns={attachmentColoumns}
                        height={480}
                      />
                    ) : (
                      <>
                        <p className="py-1">No Linked Documents Available...</p>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <ConfirmationModal
        isOpen={modalIsOpen}
        toggle={toggleModal}
        title="task"
        action={actionType === "complete" ? handleComplete : handleCloseTask}
        actionType={actionType}
      />
      <AttachmentModal
        toggle={toggleAddAttachmentModal}
        isOpen={addAttachmentModalIsOpen}
        fn={linkDocumentToTask}
      />
    </div>
  );
};

export default ViewTask;
